import { render, staticRenderFns } from "./Survey.vue?vue&type=template&id=459a6a20"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports